import elementCreation from "../elementCreation";
import formatNumbers from "../../../../helpers/formatNumbers";
import debounce from "lodash.debounce";

/* eslint-disable camelcase */
class PaymentDetailBodyComponent {
    constructor(paymentDetailBodyContainer, emitter) {
        this.maxZipLength = 5;
        this.paymentDetailBodyContainer = paymentDetailBodyContainer;
        this.emitter = emitter;
        this.termFinance = paymentDetailBodyContainer.querySelector('.payment-details__body-term');
        this.termLease = paymentDetailBodyContainer.querySelector('.payment-details__body-term--lease');
        this.zipInput = paymentDetailBodyContainer.querySelector('.input-container__zip-code input');
        this.zipError = paymentDetailBodyContainer.querySelector('.input-container__zip-code .zip-code__error');
        this.botText = paymentDetailBodyContainer.querySelector(".updates-text-bot");
        this.sideText = paymentDetailBodyContainer.querySelector(".input-container__updates-text");
        this.mpy = paymentDetailBodyContainer.querySelector('.payment-details__body-miles');
        this.downPayment = paymentDetailBodyContainer.querySelector('.input-container__down-payment');
        this.downPaymentInput = paymentDetailBodyContainer.querySelector('.input-container__down-payment input');
        this.crInput = paymentDetailBodyContainer.querySelector('.input-container__credit-rating input');
        this.paymentOptionsContainer = document.querySelector('[modal-id="online-shopper-modal"]  .payment-details__options');
        this.selectedPayment;
        this.vehicle;
        this.payments;

        this._debouncedEmitter = debounce((name, event, optionChanged) => {
            emitter.emit(name, event, optionChanged);
        }, 1000);
        this._debouncedUpdateZip = debounce(this._updateZip, 1000);

        this.emitter.on('new-vehicle-state', vehicleState => {
            this.populate(vehicleState);
        });
    }

    init(paymentSettings, dealData, personData) {
        this.paymentSettings = paymentSettings;
        this.personData = personData;
        this.dealData = dealData;
        const { lease, loan } = this.paymentSettings.finance_settings;
        const financeSettings = this.paymentSettings.finance_settings;
        let selectedLoanTerm;
        let selectedLeaseTerm;
        let defaultLoanTerm;
        let defaultLeaseTerm;
        let defaultMpy;

        this.downPaymentInput.addEventListener('focus', () => {
            this.downPaymentInput.setSelectionRange(0, 7);
        });

        this.personData.credit_estimate = this.personData && this.personData.credit_estimate ? this.personData.credit_estimate : financeSettings.credit_rating.default;
        if (this.dealData && this.dealData.vehicles && this.dealData.vehicles[0]) {
            this.vehicleState = this.dealData.vehicles[0];
            if (this.vehicleState.payments && this.vehicleState.payments.selected) {
                this.selectedPayment = this.vehicleState.payments.selected;
                this.payments = this.vehicleState.payments;
                defaultLoanTerm = financeSettings.loan.term.default;
                selectedLoanTerm = this.payments.loan.term ? this.payments.loan.term : defaultLoanTerm;
                defaultLeaseTerm = financeSettings.lease.term.default;
                selectedLeaseTerm = this.payments.lease.term ? this.payments.lease.term : defaultLeaseTerm;
                defaultMpy = this.payments.lease && this.payments.lease.miles ? this.payments.lease.miles : financeSettings.lease.miles.default;

                this.populate(this.vehicleState);
            }
        }

        this._bindEventListener(this.termFinance, 'term');
        this.termFinance.innerHTML = elementCreation.makeTermFinanceButtons(loan.term.options, selectedLoanTerm);

        this._bindEventListener(this.termLease, 'term');
        this.termLease.innerHTML = elementCreation.makeTermLeaseButtons(lease.term.options, selectedLeaseTerm);

        this._bindEventListener(this.mpy, 'miles');
        this.mpy.innerHTML = elementCreation.makeMpyButtons(lease.miles.options, defaultMpy);

        this.downPaymentInput.addEventListener("input", event => this._handleDownPayment(event));
        this.zipInput.addEventListener("input", event => this._handleZipCode(event));

        this.zipInput.addEventListener('focus', () => {
            this.zipInput.setSelectionRange(0, 5);
        });

        this._setUpMobileEvent();
        this._creditRatingSectionChange(this.personData.credit_estimate);
        this.setZipCode();
    }

    _bindEventListener(element, optionChanged) {
        element.addEventListener("change", (event) => {
            this.emitter.emit('user-changed-value', event, optionChanged);
        });
    }

    _handleDownPayment(event) {
        let inputStripped = event.target.value.replace(/[^0-9]/g, '');
        inputStripped = inputStripped.slice(0, 6);
        let inputValue = parseInt(inputStripped, 10);
        inputValue = inputValue ? inputValue : 0;
        this.downPaymentInput.value = formatNumbers(inputValue, "money");
        this._debouncedEmitter('user-changed-value', event, "down-payment");
    }

    _handleZipCode(event) {
        event.target.value = event.target.value.replace(/[^0-9]/g, '');
        this._debouncedUpdateZip(event, "zip-code");
    }

    _updateZip(event) {
        const zipVal = this.zipInput.value;
        if (zipVal.length === this.maxZipLength) {
            this.zipError.classList.add('hidden');
            if (this.sideText.classList.contains("hidden")) {
                this.botText.classList.remove('hidden');
            }
            this.zipInput.classList.remove('error');
            this.emitter.emit('user-changed-value', event, "zip-input");
        } else if (zipVal.length === 0) {
            this.zipError.classList.add('hidden');
            if (this.sideText.classList.contains("hidden")) {
                this.botText.classList.remove('hidden');
            }
            this.zipInput.classList.remove('error');
        } else {
            this.zipError.classList.remove('hidden');
            this.botText.classList.add('hidden');
            this.zipInput.classList.add('error');
        }
    }

    populate(vehicleState) {
        this.payments = vehicleState.payments;
        this.vehicleState = vehicleState;
        this.selectedPayment = vehicleState.payments.selected;
        if (vehicleState.payments[this.selectedPayment]) {
            const currentOptionData = vehicleState.payments[this.selectedPayment];
            if (currentOptionData.down_payment !== undefined) {
                this.downPaymentInput.value = formatNumbers(currentOptionData.down_payment, "money");
            }
        }
    }

    setZipCode() {
        if (this.personData && this.personData.zip) {
            this.zipInput.value = this.personData.zip;
        }
    }

    _creditRatingSectionChange(defaultCR) {
        const crin = document.querySelector('#cr-in');
        const maxLength = this.crInput.getAttribute('maxlength');
        const emitter = this.emitter;
        
        crin.addEventListener('focus', () => {
            crin.setSelectionRange(0, 3);
        });

        crin.value = defaultCR ? (defaultCR.default || defaultCR) : '';

        const creditThresholds = {
            'cr-nwork': 580,
            'cr-fair': 670,
            'cr-good': 740,
            'cr-vgood': 800,
            'cr-excellent': 1000
        };

        crin.oninput = function calcRow(event) {
            const credit = crin.value
                .replace(/[^0-9]/g, '') //remove non 0-9 characters
                .replace(/^0.*/g, '0'); //remove any characters after beginning character '0'

            for (let checkbox in creditThresholds) {
                if (credit < creditThresholds[checkbox]) {
                    document.getElementById(checkbox).checked = true;
                    break;
                }
            }

            if (crin.value.length === parseInt(maxLength) && event) {
                emitter.emit('user-changed-value', event, 'credit-rating');
            }
        };

        crin.oninput();
    }

    _setUpMobileEvent() {
        /* istanbul ignore if  */
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            let osDetailsBody = document.querySelector('[modal-id="online-shopper-modal"] .payment-details__body-container');
            let inputs = osDetailsBody.querySelectorAll('input.cui-input');
            inputs.forEach((input) => {
                /* istanbul ignore next */
                input.addEventListener('focus', () => {
                    osDetailsBody.classList.add('keyboard-open');
                    input.scrollIntoView({ behavior: "smooth" });
                });
                /* istanbul ignore next */
                input.addEventListener('blur', () => {
                    osDetailsBody.classList.remove('keyboard-open');
                });
            });
        }
    }
}

export default PaymentDetailBodyComponent;
